<template>
  <div id="FeedbackThankYou">
    <div
      :style="{ color: '#03B57C' }"
      class="top-icon-container"
    >
      <i
        class="fa fa-circle-check fa-xl"
        aria-hidden="true"
      ></i>
    </div>
    <h2 class="thank-you-title">
      Thank you!
    </h2>
    <p class="thank-you-paragraph">
      Thank you for sharing your thoughts — every response helps us support you better.
    </p>
    <b-button
      class="thank-you-home"
      size="lg"
      squared
      @click="handleHomeRedirection"
    >Return to Home
    </b-button
    >
  </div>
</template>

<script>

export default {
  name: "FeedbackThankYou",
  props: ["resetModal"],
  methods: {
    handleHomeRedirection() {
      this.$router.push('/');
      this.resetModal();
      this.$bvModal.hide("feedback-modal");
    }
  }
};
</script>
<style lang="less">

#FeedbackThankYou {
  
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 43px;
  
  .top-icon-container {
    display: flex;
    width: 120px;
    height: 120px;
    justify-content: center;
    align-items: center;
    
    .fa {
      font-size: 12rem;
    }
  }
  
  .thank-you-title {
    font-family: "DMSans Bold";
    font-weight: 700;
    font-size: 22px;
    line-height: 125%;
    letter-spacing: 0;
    text-align: center;
    color: #192550
  }
  
  .thank-you-paragraph {
    font-family: "DMSans";
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    text-align: center;
    max-width: 342px;
  }
  
  .thank-you-home {
    padding: 16px;
    color: #fff;
    font-family: "DMSans Bold";
    background-color: var(--brand-primary);
    letter-spacing: normal;
    border-radius: 15px !important;
    width: 100%;
  }
  
}
</style>
